import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import HideZeroValuesStage from '../stages/filters/HideZeroValues';
import { PipelinePhase } from '@visualizer/types';

export type HideZeroValuesParams = BlockParameters;

@AddMetadata({
    type: BlockKeys.HideZeroValues,
    name: 'Hide Zero Values',
    description: 'Remove sensors with zero value',
    unique: true,
    pipelinePhase: PipelinePhase.Pre,
    visible: false,
})
class HideZeroValuesBlock extends PipelineBlock<HideZeroValuesParams> {
    constructor(params: HideZeroValuesParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new HideZeroValuesStage()];
    }
}

export default HideZeroValuesBlock;
